"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Container = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _attachment = _interopRequireDefault(require("../../../attachment"));
var _configContext = require("../../../context/config-context");
var _functions = require("../../../utils/functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Container = exports.Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pc-cbxwghi"
});
const GridContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "GridContainer",
  class: "pc-g15rg3l4"
});

/**
 * AttachmentRow Component.
 *
 * @param {Object} props React props
 * @param {String} props.rowTitle Title for each row item
 * @param {Array} props.items Array of attachment item
 * @param {Function} props.handleChange Function to handle change event
 * @returns {React.ReactElement} AttachmentRow Component
 * @public
 */

function AttachmentRow({
  rowTitle,
  items,
  handleChange
}) {
  const {
    configData
  } = (0, _configContext.useConfig)();
  const [checkedStates, setCheckedStates] = (0, _react.useState)({});
  const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    if (configData?.instance) {
      const newCheckedStates = {};
      const newSelectedOptions = {};
      items?.forEach(item => {
        const [product, displayArea, itemName] = (0, _functions.parseInstancePath)(item.instancePath);
        const isPillToggle = item.options && item.options.length > 1;
        const storedSelection = configData.instance[product]?.[displayArea]?.[itemName]?.selection;
        newCheckedStates[item.instancePath] = Boolean(storedSelection && storedSelection !== 'none');
        if (isPillToggle && item.options && item.options.length > 0 && storedSelection && storedSelection !== 'none') {
          const optionIndex = item.options.findIndex(opt => (opt.value || opt._name || '') === storedSelection);
          if (optionIndex !== -1) {
            newSelectedOptions[item.instancePath] = optionIndex;
          } else {
            newSelectedOptions[item.instancePath] = 0;
          }
        }
      });
      setCheckedStates(newCheckedStates);
      setSelectedOptions(newSelectedOptions);
    }
  }, [configData, items]);
  const handleSetChecked = (itemInstancePath, newState) => {
    setCheckedStates(prevState => ({
      ...prevState,
      [itemInstancePath]: newState
    }));
  };
  if (!items) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-cy": "attachment-row-item",
    className: rowTitle ? 'hasBorder' : ''
  }, rowTitle && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    text: rowTitle,
    size: 5,
    "data-cy": "row-title"
  }), /*#__PURE__*/_react.default.createElement(GridContainer, null, items?.map((item, index) => {
    const isChecked = checkedStates[item.instancePath] ?? false;
    const {
      id,
      instancePath,
      displayDisable,
      attachmentImage,
      attachmentSubtitle,
      options
    } = item;
    const isPillToggle = options && options.length > 1;
    const selectedOptionIndex = selectedOptions[instancePath] || 0;
    let inputValue = id;
    if (isPillToggle && options && options.length > 0 && selectedOptionIndex >= 0) {
      const selectedOption = options[selectedOptionIndex];
      inputValue = selectedOption?.value || selectedOption?._name || id;
    }
    return /*#__PURE__*/_react.default.createElement(_attachment.default, (0, _extends2.default)({
      key: index
    }, item, {
      onChange: (checked, inputName, value) => handleChange(checked, inputName, value, isPillToggle),
      inputName: instancePath,
      inputValue: inputValue,
      displayDisable: displayDisable,
      checked: isChecked,
      setChecked: newState => handleSetChecked(instancePath, newState),
      image: attachmentImage,
      secondaryTitle: attachmentSubtitle,
      options: isPillToggle ? options : [],
      selectedOption: selectedOptionIndex
    }));
  })));
}
var _default = exports.default = AttachmentRow;
AttachmentRow.propTypes = {
  rowTitle: _propTypes.default.string,
  items: _propTypes.default.array,
  handleChange: _propTypes.default.func
};